// Module
var code = "<i class=\"icon-X small\" ng-click=\"editTargetCtrl.removeManualPhrases(row)\"></i> &nbsp;\n<div class=\"emojis e-{{row.id}} inline-block\"></div>";
// Exports
module.exports = code;